<mat-card class="transparent-card">
    <mat-card-header>
        <mat-card-title>Meal Counter</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-form-field>
            <mat-label>Search</mat-label>
            <input matInput (keyup)="mealCounterSearch($event)">
        </mat-form-field>
        <table mat-table class="transparent-table" [dataSource]="mealCounterSource" matSort >
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.date | date:'dd.MM.yyyy ' }}
                </td>
            </ng-container>
            <ng-container matColumnDef="aaa">
                <th mat-header-cell *matHeaderCellDef>AAA</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.aaa }}
                </td>
            </ng-container>
            <ng-container matColumnDef="crew">
                <th mat-header-cell *matHeaderCellDef>RGA Crew</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.crew }}
                </td>
            </ng-container>
            <ng-container matColumnDef="visitor">
                <th mat-header-cell *matHeaderCellDef>Visitor</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.visitor }}
                </td>
            </ng-container>
            <ng-container matColumnDef="creator">
                <th mat-header-cell *matHeaderCellDef>Creator</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.creator }}
                </td>
            </ng-container>
            <ng-container matColumnDef="security">
                <th mat-header-cell *matHeaderCellDef>Security</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.security }}
                </td>
            </ng-container>
            <ng-container matColumnDef="voucher">
                <th mat-header-cell *matHeaderCellDef>Voucher</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.voucher }}
                </td>
            </ng-container>
            <ng-container matColumnDef="other">
                <th mat-header-cell *matHeaderCellDef>Other</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.other }}
                </td>
            </ng-container>
            <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef>Total</th>
                <td mat-cell *matCellDef="let badgeLog">
                    {{ badgeLog.total }}
                </td>
            </ng-container>
            <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let badgeLog">
                    <mat-icon (click)="deleteLog(badgeLog.date)">delete</mat-icon>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator class="transparent-paginator" [pageSizeOptions]="[25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
</mat-card>